export default __webpack_public_path__ + "static/media/pdf.d4ec8818.svg";